import { AppointmentStatus } from "@myapp/contract";
import { getAppointmentStatusColor } from "../../../entities/appointment";

type Props = {
  title: string;
  statusLabel: string;
  status: AppointmentStatus;
};

export const AppointmentHeader = ({ title, statusLabel, status }: Props) => {
  const statusClass = 'text-sm font-medium mt-0.5'
  const statusStyle = { color: getAppointmentStatusColor(status) }

  return (
    <div>
      <h1 className="text-xl font-bold text-blue-900">
        Reparaturauftrag {title}
      </h1>
      <p className={statusClass} style={statusStyle}>
        {statusLabel}
      </p>
    </div>
  );
};
